import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { drawTransformSchema } from './Draw.js';

export const drawResponseTransformSchema = z
  .object({
    draw: drawTransformSchema,
  })
  .transform(({ draw }) => ({ data: draw }));

export const drawApiResponse = {
  parse: (data: unknown) => z.union([drawResponseTransformSchema, apiErrorSchema]).parse(data),
} as const;
